export const SET_INITIALIZED = "app/SET_INITIALIZED";
export const SET_COOKIE = "app/SET_COOKIE";
